import React from 'react';
import { Button } from 'ui'
import {FormControl, FormGroup, InputGroup} from 'ui'

function getSearchText(isLoading, isFetching, searchTerm, count, total) {
  // Only show loading state when we have a search term and are fetching
  if ((isLoading || isFetching) && searchTerm) {
    return <span>Searching...</span>
  }
  
  // Show results when we have a search term (meaning a search was performed)
  if (searchTerm && !isLoading && !isFetching) {
    if (count > 0) {
      if (!!total) {
        return <span>Showing {count} results, appearing in {total} transcripts.</span>;
      } else {
        return <span>Showing {count} results.</span>;
      }
    } else {
      return <span>We couldn't find <strong>{searchTerm}</strong> in any transcripts.</span>;
    }
  }

  return <span></span>;
}

function isDisabled(searchText) {
  return !searchText || searchText.length === 0;
}

const SearchBar = ({isLoading, isFetching, count, total, searchTerm, searchText, onSubmit, onSearchTextChange}) => {
  const paddingTop = 10;
  const height = 100;

  const resultText = getSearchText(isLoading, isFetching, searchTerm, count, total);

  return (
    <div style={{paddingTop: paddingTop, margin: 0, paddingBottom: 0, height: height}}>
      <FormGroup style={{marginBottom: 5, padding: 0}}>
        <InputGroup>
          <form onSubmit={onSubmit}>
            <InputGroup.Button>
              <FormControl type="text"
                  value={searchText}
                  onChange={onSearchTextChange}
              />
              <Button
                type="submit"
                variant="blue"
                disabled={isDisabled(searchText)}>
                  Search
                </Button>
            </InputGroup.Button>
          </form>
        </InputGroup>
      </FormGroup>

      <div style={{marginTop:20}}>
        <p>{resultText}</p>
      </div>
    </div>
  );
}

export default SearchBar;